module.exports = __webpack_public_path__ + "img/bar.53fa9b36.png";